import { useState, useCallback } from 'react';

/**
 * Tracks one in-flight action at a time, keyed by (action name, row id),
 * so a table can show a spinner on exactly the button that was clicked.
 */
export default function usePendingAction() {
  const [pending, setPending] = useState(null);

  const run = useCallback(async (key, id, fn) => {
    setPending({ key, id });
    try {
      await fn();
    } finally {
      setPending(null);
    }
  }, []);

  const isPending = useCallback(
    (key, id) => pending?.key === key && pending?.id === id,
    [pending],
  );

  return { isPending, run };
}
